<template>
  <div class="bg-white-wrapper">
    <div class="container payment-wrapper">
      <!-- <h3 class="payment-header">
        <img src="../../assets/images/pay-logo-wxt.png" />
      </h3>-->
      <div class="payment-info">
        <div class="payment-order">
          <p>
            <b>商品名称：</b>
            <span>{{orderInfo.productName}}</span>
          </p>
          <p>
            <b>应付总额：</b>
            <span class="payment-money">￥{{Number(orderInfo.orderMoney).toFixed(2)}}</span>
          </p>
        </div>
        <div class="clearfix">
          <div class="payment-qrcode" v-show="payQrcodeText.wxqr">
            <div class="payment-qrcode-box wxpay">
              <p>扫一扫，向我付款</p>
              <p>
                <span id="qrcode">
                  <img :src="concatImageUrl(payQrcodeText.wxqr)" width="220" height="220" alt="付款二唯码" class="qrcode" />
                </span>
              </p>
            </div>
            <div class="payment-qrcode-logo">
              <img src="../../assets/images/pay-logo-wx.png" height="60" />
            </div>
          </div>
          <div class="payment-qrcode" v-show="payQrcodeText.aliqr">
            <div class="payment-qrcode-box alipay">
              <p>扫一扫，向我付款</p>
              <p>
                <span id="qrcode">
                  <img :src="concatImageUrl(payQrcodeText.aliqr)" width="220" height="220" alt="付款二唯码" class="qrcode" />
                </span>
              </p>
            </div>
            <div class="payment-qrcode-logo">
              <img src="../../assets/images/pay-logo-alipay.png" />
            </div>
          </div>
        </div>

        <div class="payment-text">
          <p>支付成功后，请告知教务老师购课订单编号开通课程，电话：({{payQrcodeText.payTel}})</p>
          <p>
            订单编号：
            <b>{{orderInfo.orderNo}}</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { getOrderInfo, getPayQrcode } from "../../utils/localStorage";
import { order } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      orderInfo: {
        orderNo: "",
        orderMoney: 0,
        productName: ""
      },
      payQrcodeText: {
        wxqr: "",
        aliqr: "",
        payTel: ""
      }
    };
  },
  mounted() {
    this.initOrderInfo();
    this.getPayData();
  },
  methods: {
    initOrderInfo() {
      this.orderInfo = getOrderInfo();
    },
    getPayData() {
      this.payQrcodeText = getPayQrcode();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var";
.payment-wrapper {
  padding: 10px 0;
  .payment-header {
    color: #000;
    font-size: 2rem;
    font-weight: normal;
    padding: 1.6rem 0;
    img {
      width: 232px;
      height: 36px;
    }
  }
  .payment-info {
    padding: 30px 50px;
    background-color: #fff;
    border: 1px solid #f0f0f0;
    text-align: left;
    .payment-order {
      margin-top: 1.6rem;
      p {
        line-height: 3rem;
        .payment-money {
          font-size: 2.4rem;
          color: #1296db;
        }
      }
    }
    .payment-qrcode {
      float: left;
      margin-top: 3rem;
      margin-right: 8rem;
      .payment-qrcode-box {
        width: 350px;
        height: 350px;

        margin: 0 auto;
        &.wxpay {
          background-color: #2ead38;
        }
        &.alipay {
          background-color: #0f5796;
        }
        p {
          text-align: center;
          &:first-child {
            font-size: 20px;
            color: #fff;
            padding-top: 20px;
          }
          &:last-child {
            margin: 25px auto 0 auto;
            width: 220px;
            height: 220px;
            border-radius: 10px;
            overflow: hidden;
            background: #fff;
            position: relative;
            span {
              position: absolute;
              left: 0;
              top: 0;
              width: 220px;
              height: 220px;
              z-index: 2;
            }
          }
        }
      }
      .payment-qrcode-logo {
        margin-top: 1.6rem;
        text-align: center;
        img {
          display: inline-block;
          height: 60px;
        }
      }
    }
    .payment-text {
      margin-top: 3rem;
      width: 100%;
      text-align: left;
      p {
        &:first-child {
          font-size: 18px;
          color: #0095d3;
        }
        &:last-child {
          font-size: 16px;
          margin-top: 1.6rem;
        }
      }
    }
  }
}
</style>